<template>
  <v-snackbar v-model="errors" top color="error">
    <v-alert type="error" prominent dense>
      <v-row v-for="(error, index) in errors" :key="index" align="center">
        <v-col>
          <v-row>{{ error.detail }}</v-row>
          <v-row v-if="error.timestamp">Timestamp: {{ error.timestamp | formatDate_ddmmyyyyhhmm_slash }}</v-row>
        </v-col>
        <v-col cols="auto">
          <icon-button icon="mdi-close" @click="errors.splice(index)" />
        </v-col>
      </v-row>
    </v-alert>
  </v-snackbar>
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import IconButton from '@/components/button/IconButton.vue';
import NotificationService from '@/services/NotificationService';

@Component({
  components: { IconButton },
})
export default class Alert extends Vue {
  @Inject('notificationService') notificationService: NotificationService;

  created() {
    setTimeout(() => {
      this.notificationService.clearErrors();
    }, 5000);
  }

  @Prop() readonly errors!: [];
}
</script>
